// extracted by mini-css-extract-plugin
export default {"title":"ALMExtensionIframeDialog_title__Do6aR","iframe":"ALMExtensionIframeDialog_iframe__Wqouo","primeAlertDialogButton":"ALMExtensionIframeDialog_primeAlertDialogButton__GJvY1"};